import { Injectable } from '@angular/core';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager } from 'src/app/managers/request/request.manager';
import { ErrorManager } from 'src/app/managers/error/error.manager';
import { DeviceStatus } from 'src/app/beans/device/device-status.bean';

@Injectable({
  providedIn: 'root',
})
export class DeviceStatusHandler {
  constructor(
    private _utils: UtilsManager,
    private _notifier: NotifierManager,
    private _request: RequestManager,
    private _error: ErrorManager
  ) {}

  async get(siteId: number) {
    if (!this._utils.checker().isValidId(siteId)) {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_SITE_ID);
      return undefined;
    }

    try {
      let response = await this._request.deviceStatus().get(siteId).toPromise();

      // if (this._error.hasError(response)) {
      //   // MANAGE ERROR
      //   return this._error.handleCQWebapp(response);
      // }

      return response as DeviceStatus[];
    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined;
    }
  }
}
